// src/Tr.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Tr_default = createIcon({
  displayName: "Tr",
  viewBox: "0 0 48 32",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        x: "1",
        y: "1",
        width: "48",
        height: "32",
        fill: "#FF1A26",
        stroke: "#F3F6F9"
      }),
      /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.6209 9.97068C28.805 9.66635 27.9219 9.5 27 9.5C22.8579 9.5 19.5 12.8579 19.5 17C19.5 21.1421 22.8579 24.5 27 24.5C27.9219 24.5 28.805 24.3336 29.6209 24.0293C28.0807 25.2625 26.1265 26 24 26C19.0294 26 15 21.9706 15 17C15 12.0294 19.0294 8 24 8C26.1265 8 28.0807 8.7375 29.6209 9.97068Z",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M32.5376 18.2275L31.1942 20.7364L30.6918 17.9351L27.8905 17.4327L30.3994 16.0893L30.0116 13.2699L32.0645 15.2409L34.6261 14.0008L33.386 16.5623L35.357 18.6153L32.5376 18.2275Z",
        fill: "white"
      })
    ]
  })
});

export {
  Tr_default
};
